define('modules/lp_leads/models/lead',['require','exports','module','backbone'],function(require, exports, module){

  var Backbone = require("backbone");

  module.exports = Backbone.Model.extend({

  });

});

